// components/GallerySection.jsx
import React from "react";

const images = [
  "/image1.png",
  "/image2.png",
  "/image3.png",
  "/image4.png",
  "/image5.png",
  "/image6.png",
];

const GallerySection = () => {
  return (
    <section className="relative py-16 px-4 md:px-10 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
            Gallery
          </span>

          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900">
            Our{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Campus Moments
            </span>
          </h2>

          <p className="text-gray-600 mt-3 text-sm md:text-base">
            Glimpses of activities, events and campus life.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-4">
          {images.map((img, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-md group"
            >
              <img
                src={img}
                alt={`gallery-${index}`}
                className="w-full h-44 md:h-56 object-cover group-hover:scale-110 transition duration-500"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default GallerySection;